import { IItem, IItemLvl, Item } from "./Item";
import Character from '../characters/Character'
import { soundToPlay } from "../sounds/sound";
import Inventory from "../inventory/Inventory";
import bones from '../../assets/img/bones.png'
import bonesWebp from '../../assets/img/bones.webp'

export type TArmor = 'light' | 'medium' | 'heavy ' | null

export const initArmor: IItem = {
    initType: 'armor',
    initCount: 1,
    initCost: 0,
    initImages: { webp: '', img: '' },
    initArmorType: null,
    initWeaponType: null,
    initStackable: false,
    initName: 'armor',
    initRestoreValue: 0,
    initArmorValue: 0,
    initWeaponDamage: 0
}

export class Armor extends Item {
    armorType: TArmor
    protected armorValue: number

    constructor(armor: IItem) {
        super(armor)
        this.armorType = armor.initArmorType
        this.armorValue = this.definitionArmorValue()
        this.itemLvl = {
            lvl: 1,
            itemToLvlUpName: 'bones',
            itemToLvlUpAmount: 10,
            itemToLvlUpImg: { webp: bonesWebp, img: bones }
        }
    }

    getArmorType() {
        return this.armorType
    }

    getArmorValue(): number {
        return this.armorValue
    }

    useItem(character: Character) {
        if (this.getCount() <= 0) return
        character.wearingArmor(this)
        this.setCount(this.getCount() - 1)
        soundToPlay("armor")
    }

    remove(character: Character, characterInventory: Inventory) {
        this.setCount(1)
        characterInventory.pushInInventory(this)
        character.removeArmor()
        soundToPlay("armor")
    }

    definitionArmorValue() {
        switch (this.armorType) {
            case 'light':
                return 1
            case 'medium':
                return 2
            case 'heavy ':
                return 3
            default:
                return 0
        }
    }

    getClone() {
        return new Armor({
            initType: this.type,
            initCount: this.count,
            initCost: this.cost,
            initImages: this.images,
            initArmorType: this.armorType,
            initWeaponType: null,
            initStackable: this.stackable,
            initName: this.name,
            initRestoreValue: this.restoreValue,
            initArmorValue: this.armorValue,
            initWeaponDamage: this.weaponDamage
        })
    }

    setItemLvl() {
        const newLvl = this.itemLvl.lvl + 1
        const newItemToLvlUpAmount = this.itemLvl.itemToLvlUpAmount + 10
        const newArmorValue = this.armorValue + 1

        this.itemLvl = {
            ...this.itemLvl,
            lvl: newLvl,
            itemToLvlUpAmount: newItemToLvlUpAmount
        }

        this.armorValue = newArmorValue
    }
}